module.exports = __webpack_public_path__ + "media/images/cart/kuroneko-daibiki-9c3cc7b7e182c7d9c9b22c05c7f6a672.png";